type Props = {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
};

const Pagination = ({ page, totalPages, onChange }: Props) => {
  if (totalPages <= 1) return null;

  const goTo = (p: number) => {
    if (p < 1 || p > totalPages || p === page) return;
    onChange(p);
  };

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-center gap-2 mt-6 select-none">
      {/* Previous */}
      <button
        onClick={() => goTo(page - 1)}
        disabled={page === 1}
        className={`
          px-3 py-2 rounded-lg border text-sm font-medium
          transition
          ${
            page === 1
              ? "bg-slate-100 text-slate-400 cursor-not-allowed"
              : "bg-white hover:bg-slate-50"
          }
        `}
      >
        ←
      </button>

      {/* Numbers */}
      {pages.map((p) => (
        <button
          key={p}
          onClick={() => goTo(p)}
          className={`
            min-w-[36px] h-[36px] rounded-lg text-sm font-semibold
            transition
            ${
              p === page
                ? "bg-brand-sidebar text-white"
                : "bg-white hover:bg-slate-50 border"
            }
          `}
        >
          {p}
        </button>
      ))}

      {/* Next */}
      <button
        onClick={() => goTo(page + 1)}
        disabled={page === totalPages}
        className={`
          px-3 py-2 rounded-lg border text-sm font-medium
          transition
          ${
            page === totalPages
              ? "bg-slate-100 text-slate-400 cursor-not-allowed"
              : "bg-white hover:bg-slate-50"
          }
        `}
      >
        →
      </button>
    </div>
  );
};

export default Pagination;
